<template>
    <b-modal v-if="tracks!=null"
             ref="modal"
             centered
             :visible="tracks.length > 0"
             @hidden="cancelModal"
             modal-class="modal-condensed">
        <template slot="modal-header">
            <h1>{{ Translations.sections.tracks.edition.artists }}</h1>
            <div>
                <Button :empty="true" class="close-popup" @click.prevent="cancelModal">{{ Translations.buttons.cancel }}</Button>
                <Button :empty="false" :noBorder="true" color="#d2d2d2" class="validate" @click.prevent="updateTracks">
                    Done
                </Button>
            </div>
        </template>
        <template>
            <div class="flex-container">
                <form class="form-container search">
                    <input type="text" ref="inputSearch" v-focus maxlength="100" placeholder="Search artist" v-model="searchData.searchTerm" @change="searchDelay(150)" />
                    <Button :empty="true" :noBorder="true" @click.prevent="searchDelay(0)">
                        <i class="fas fa-search"></i>
                    </Button>
                </form>
                <div class="search-result">
                    <template>
                        <WaitingBlock v-if="modalState.isLoadingArtists"></WaitingBlock>

                        <template v-else-if="searchResult!=null && searchResult.dataItem !=null && searchResult.dataItem.items !=null && searchResult.dataItem.items.length > 0">
                            <div class="search-result__container">
                                <div v-for="artist in searchResult.dataItem.items" :key="`selectorArtist-${artist.id}`" :class="['artist-container',{'selected' : selectedArtists[artist.id] !== undefined}]" @click.prevent="toggleArtist(artist)">
                                    <i :class="['far', selectedArtists[artist.id] === undefined ? 'fa-square':'fa-check-square']"></i>
                                  <span v-if="artist.countryOrigin" class="flag-icon flag-icon-squared"
                                        :class="['flag-icon-' + artist.countryOrigin.toLowerCase()]"
                                        v-tooltip="{data:' ' + artist.countryName }" style="margin-left: 7px; min-width: 30px ;margin-right: -12px;"
                                  ></span>
                                    <span v-if="!artist.countryOrigin" style="margin-left: 7px; min-width: 30px;margin-right: -12px;">&nbsp;</span>
                                    <span class="name">{{artist.name}} &nbsp;&nbsp;&nbsp;</span>

                                </div>
                            </div>
                            <div class="no-result-container">
                                <header v-if="!noModalUpdate">
                                    <strong>Do you want to create a new artist ?</strong>
                                </header>
                                <div class="form-container creation" v-if="modalState.hasSearchProcessed && !noModalUpdate">
                                    <label class="creation-title">Create a new artist</label>
                                    <div class="creation-form">
                                        <input type="text" v-model="creationData.name" placeholder="Add a new artist" />
                                        <Button :empty="true" :noBorder="true" @click.prevent="createArtist()" :disabled="modalState.isCreatingArtist"><i class="fas fa-plus"></i></Button>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <div v-else class="no-result-container">
                            <header>
                                <strong>No artist matching your search criteria</strong>
                            </header>
                            <div class="form-container creation" v-if="modalState.hasSearchProcessed && !noModalUpdate">
                                <label class="creation-title">Create a new artist</label>
                                <div class="creation-form">
                                    <input type="text" v-model="creationData.name" placeholder="Add a new artist" />
                                    <Button :empty="true" :noBorder="true" @click.prevent="createArtist()" :disabled="modalState.isCreatingArtist"><i class="fas fa-plus"></i></Button>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </template>
        <template slot="modal-footer">
            <div>
                <div class="selection-container">
                    <template  v-if="selectedArtistsData.artists.length > 0">
                        <header>{{selectedArtistsData.length}} selected artists :</header>
                        <section>
                            <div v-for="artist in selectedArtistsData.artists" @click.prevent="toggleVisibility(artist)"
                                 :key="artist.id"
                                 :class="['badge', 'artist-badge',{'selected' : selectedArtists[artist.id] === undefined}]">
                                <span class="visible"><i :class="['far', artist.isVisible?'fa-eye':'fa-eye-slash']"></i></span>
                                <span class="name">{{artist.name}}</span>
                                <span class="selector">
                                    <i class="fas fa-trash" @click.prevent="toggleArtist(artist)"></i>
                                </span>
                            </div>
                        </section>
                    </template>
                </div>
            </div>
        </template>
    </b-modal>
</template>

<script>
    import Vue from 'vue'
    import Button from'@/components/common/Button';
    import Bootstrap from 'bootstrap-vue';
    import store from '@/store';
    import router from '@/router';
    import Translations from '@/store/translations';
    import EventBus from '@/eventbus';
    import Portlet from '@/components/common/Portlet.vue';
    import { HTTP } from "@/utils/http";
    import Apis from '@/apis/index';
    import { mapState } from 'vuex';
    import WaitingBlock from'@/components/common/WaitingBlock';

    export default {
        name: 'SelectorArtists',
        components: { Portlet, Bootstrap, Button, WaitingBlock },
        computed: {
            Translations: () => Translations,
            trackUids() {
                return this.tracks.map(track => track.uid)
            },
            selectedArtistsData() {
                return {
                    length: Object.keys(this.selectedArtists).length,
                    artists: Object.values(this.selectedArtists)
                        .sort(function (a, b) {
                            return a.displayOrder - b.displayOrder;
                        })
                }
            }
        },
        props: {
            stationUid: { required: true },
            multiselect: { required: false, default: true },
            noModalEdit: null,
            noModalUpdate: true,
        },
        directives: {
            focus: {
                // When the bound element is inserted into the DOM...
                inserted: function (el) {
                    // hack to trigger inside method
                    setTimeout(() => {
                        el.focus();
                    }, 0)
                }
            }
        },
        data() {
            return {
                modalState: {
                    hasSearchProcessed: false,
                    isCreationActive: false,
                    isLoadingArtists: false,
                    delayedSearch: null
                },
                tracks: [],
                selectedArtists: {},
                searchResult: null, creationResult: null,
                creationData: {
                    name: ""
                },
                searchData: {
                    searchTerm: "",
                    pageSize: 2000,
                    page: 1,
                }
            };
        },
        methods: {
            toggleVisibility(artist) {
                const keys = Object.keys(this.selectedArtists);
                if (keys.includes(artist.id && artist.id.toString())) {
                    this.selectedArtists = {
                        ...this.selectedArtists,
                        [artist.id]: {
                            ...this.selectedArtists[artist.id],
                            isVisible: !artist.isVisible
                        }
                    }
                }
            },
            // ------------------------------------------------------
            /* Start : Common Behaviour */
            // ------------------------------------------------------
            show() {
                this.$refs.modal.show();
            },
            edit(artists) {
                console.log(artists);
                if (!artists) {
                    this.show();
                    return;
                }

                const arts = artists.reduce((acc, item) => {
                    acc[item.id] = item;
                    return acc;
                }, {});

                this.selectedArtists = arts;
                console.log(arts);

                this.show();
            },
            editForTracks(tracks) {
                var tmpArtists = {};
                this.tracks = tracks;
                if (this.tracks.length === 1) {
                    var source = (this.tracks[0].artists || []).map(x => Object.assign({}, x));

                    for (var i = 0; i < source.length; i++) {
                        console.log("---> Artist : ", source[i]);
                        tmpArtists[source[i].id] = source[i];
                    }

                    // Pre-select the artist name if none are linked
                    if (this.tracks[0].artist && !this.tracks[0].artists) {
                        this.searchData.searchTerm = this.tracks[0].artist
                        this.search()
                    }
                }
                this.selectedArtists = tmpArtists;
                this.show();
            },
            searchDelay(delay) {
                if (this.delayedSearch != null) clearTimeout(this.delayedSearch);
                this.delayedSearch = setTimeout(this.search, delay || 150);
            },
            search() {
                // console.log("Search Started", this.searchData);
                this.modalState.isLoadingArtists = true;
                this.creationData.name = this.searchData.searchTerm;
                HTTP.post(Apis.artists.search, this.searchData)
                    .then(this.searchEnd)
                    .catch(this.searchError)
                    .then(this.searchCompleted)
            },
            searchEnd(response) {
                this.searchResult = response.data;
            },
            searchError(response) {
                this.searchResult = response.data;
            },
            searchCompleted(response) {
                this.modalState.isLoadingArtists = false;
                this.modalState.hasSearchProcessed = true;
            },
            cancelModal() {
                this.modalState.hasSearchProcessed = true;
                this.searchData.searchTerm = "";
                this.creationData.name = "";

                if (document.activeElement) {
                    document.activeElement.blur();
                }

                this.$emit("onHidden");
                this.$refs['modal'].hide();
            },
            // ------------------------------------------------------
            /* End : Common Behaviour */
            // ------------------------------------------------------
            // test automatic build
            toggleAdd() {
                this.modalState.isCreationActive = !this.modalState.isCreationActive;
            },
            async updateTracks() {
                var result = null;

                if (this.noModalEdit) {
                    this.cancelModal();
                    this.$emit('newValue', 'artists', this.selectedArtistsData.artists);
                    return;
                }

                try {
                    var data = {
                        stationUid: this.stationUid,
                        keys: this.trackUids,
                        values: this.selectedArtistsData.artists.map((art) => { return { artistId: art.id, isVisible: art.isVisible } })
                    };
                    result = await HTTP.post(Apis.library.tracks.update.artists, data);
                    if (result.data.dataItem != null) {
                        for (var idxTrack in this.tracks) {
                            var track = this.tracks[idxTrack];
                            var uid = track.uid;
                            if (uid === undefined) continue;
                            var updatedTrack = result.data.dataItem[uid];
                            if (updatedTrack != null) {
                                track.artists = updatedTrack.artists || [];
                                track.warnings = updatedTrack.warnings;
                                track.isFilled = updatedTrack.isFilled;
                                this.cancelModal();
                            }
                        }
                    }
                }
                catch (error) {
                    console.log("Update Result Error:", error);

                    result = error.response.data;
                }
                if (result != null && result.errors && result.errors.length == 0) {
                    this.cancelModal();
                }
                else {
                    // an error occured : show it
                }
            },
            toggleArtist(artist) {
                const keys = Object.keys(this.selectedArtists)
                if (keys.includes(artist.id.toString())) {
                    Vue.delete(this.selectedArtists, artist.id);
                } else {
                    if (!this.multiselect) {
                        this.selectedArtists = {};
                    }
                    const newArtist = artist;
                    newArtist.isVisible = true;
                    newArtist.displayOrder = new Date().getTime();
                    this.selectedArtists = { ...this.selectedArtists, [artist.id]: newArtist };
                }
            },
            createArtist() {
                 this.modalState.isCreatingArtist = true;
                 if(this.creationData.name) {
                   HTTP.post(Apis.artists.create, this.creationData)
                       .then(this.createEnd)
                       .catch(this.createError)
                       .then(this.createCompleted)
                 }

            },
            createEnd(response) {
                this.creationResult = response.data;
                if (this.creationResult.dataItem != null) {
                    this.searchData.searchTerm = this.creationResult.dataItem.name,
                        this.toggleArtist(this.creationResult.dataItem);
                    this.search();
                    this.modalState.isCreationActive = false;
                    this.creationData.name = "";
                }
            },
            createError(error) {
                this.creationResult = error.response.data;
            },
            createCompleted(response) { this.modalState.isCreatingArtist = false; },

        }
    }
</script>

<style lang="scss" scoped>
    .artist-container {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0px 10px;
        cursor: pointer;
    }

    .no-result-container header {
        padding: 30px 25px 20px;

        strong {
            font-size: 17px;
        }
    }

    .name {
        width: 100%;
        display: block;
        overflow: hidden;
        text-overflow: ellipsis;
        margin: 0 1em;
    }

    .selector i,
    .visible i {
        cursor: pointer;
    }

    .flex-container {
        display: flex;
        flex-direction: column;
    }

    .form-container {
        padding: 10px 25px;
        background: white;
    }

    .creation {
        display: block !important;

        &-title {
            display: block;
            padding-top: 0;
            padding-bottom: 0;
            margin-bottom: 10px;
            font-size: 14px;
            font-weight: 600;
        }

        &-form {
            display: flex;
        }
    }

    .form-container.search {
        box-shadow: 0 5px 5px -5px #d2d2d2;
        position: sticky;
        top: 0px;
    }

    .search-container {
        overflow: hidden;
        display: flex;
        flex-direction: column;
    }

    .selection-container {
        background: white;
        max-height: 150px;
        overflow-y: auto;
        display: block;
        box-shadow: 0 -5px 5px -5px white;
        width: 100%;
    }

    .selection-container header {
        position: sticky;
        top: 0px;
        font-weight: 600;
        font-size: 13px;
        text-decoration: underline;
        background: white;
        padding: 10px 0;
    }

    .selection-container section {
        padding: 0 0;
        display: flex;
        flex-wrap: wrap;
    }

    .selection-container .badge {
        border-radius: 100px;
        display: inline-flex;
        padding: 5px 10px;
        color: white;
        align-items: center;
        margin: 5px;

        .name {
            flex-shrink: 0;
            width: auto;
        }
    }

    .far.fa-eye {
        color: white;
    }

    .far.fa-eye-slash {
        color: #FF2213;
    }

    .search-result {
        height: 400px;
        overflow: auto;
        max-height: 400px;
        .search-result__container {
            height: 240px;
            overflow-y: auto;
        }
    }
</style>
